import { API_CONFIG } from '@/lib/api/config';

export function absoluteApiUrl(path: string): string {
  const base = (API_CONFIG.BASE_URL || '').replace(/\/+$/, '');
  const suffix = path.startsWith('/') ? path : `/${path}`;

  if (/^https?:\/\//i.test(base)) return `${base}${suffix}`;

  const relativeBase = base || '/api/v1';
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${relativeBase}${suffix}`;
  }
  return `${relativeBase}${suffix}`;
}
